import React, { useState, useEffect } from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import { capitalize } from 'underscore.string'
import Switch from '@mui/material/Switch'

import LayoutContext from '../../../../store/Layout/contexts'
import AlertService from "../../../../components/SweetAlert";
import ToastUtil from "../../../../components/ToastNotification/ToastUtil";
import { GET, POST, PUT, DELETE, newFetch } from '../../../../helpers/fetch'

const EditPulse = ({
  history,
  match: {
    params: { client_id }
  }
}) => {
  const [client, setClient] = useState(null)
  const [autoPulse, setAutoPulse] = useState(false)
  const [questions, setQuestions] = useState([])
  const [oldQuestions, setOldQuestions] = useState([])
  const [newQuestions, setNewQuestions] = useState([])

  // const [oldTextArea, setOldTextArea] = useState('')
  // const [oldType, setOldType] = useState('text')

  const [newTextArea, setNewTextArea] = useState('')
  const [newType, setNewType] = useState('text')

  const [addActive, setAddActive] = useState(false)
  const [addTextArea, setAddTextArea] = useState('')
  const [addType, setAddType] = useState('text')

  const fetchClient = async () => {
    let api_path = `/client/${client_id}`
    let response = await newFetch(GET, api_path)

    if (response.success) {
      setClient(response.data)
    }
  }

  const fetchClientSurveys = async () => {
    let api_path = `/client/${client_id}/survey`
    let response = await newFetch(GET, api_path)

    setQuestions(response.data)
    setOldQuestions(
      response.data.map(question => ({ ...question, edit_active: false }))
    )
  }

  const handleEditView = async (type, i) => {
    if (addActive && addTextArea) {
      if (
        await AlertService.confirm("", 'You are in the middle of adding a new question. Please save the new question before editing other questions. Are you sure you want discard the new question and continue to edit the chosen question?')
      ) {
        setAddTextArea('')
        setAddType('text')
      } else {
        return false
      }
    }

    // let oldActive = oldQuestions.find(q => q.active)
    let newActive = newQuestions.find(q => q.active)

    // if (
    //   (oldActive &&
    //     (oldActive.question !== oldTextArea ||
    //       oldActive.answer_type !== oldType)) ||
    //   (newActive &&
    //     (newActive.question !== newTextArea ||
    //       newActive.answer_type !== newType))
    // ) {
    if (
      newActive &&
      (newActive.question !== newTextArea || newActive.answer_type !== newType)
    ) {
      const isConfirmed = await AlertService.confirm("", 'You are in the middle of editing a question. Please save the editted question before editing other questions. Are you sure you want discard the editted question and continue to edit the chosen question?');
      if (
        !isConfirmed
      ) {
        return false
      }
    }

    let cloneOld = [...oldQuestions]
    let cloneNew = [...newQuestions]

    cloneOld = cloneOld.map(question => ({
      ...question,
      edit_active: false
    }))
    cloneNew = cloneNew.map(question => ({
      ...question,
      edit_active: false
    }))

    if (type === 'old') cloneOld[i].edit_active = !cloneOld[i].edit_active
    if (type === 'new') cloneNew[i].edit_active = !cloneNew[i].edit_active

    setAddActive(false)
    setOldQuestions(cloneOld)
    setNewQuestions(cloneNew)
  }

  // const handleSaveOldQuestion = i => {
  //   let clone = [...oldQuestions]

  //   clone[i].question = oldTextArea
  //   clone[i].answer_type = oldType

  //   clone = clone.map(question => ({
  //     ...question,
  //     active: false
  //   }))

  //   setOldQuestions(clone)
  // }

  const handleCancelEditOldQuestion = i => {
    let clone = [...oldQuestions]
    clone[i].edit_active = !clone[i].edit_active
    setOldQuestions(clone)
  }

  const handleSaveNewQuestion = i => {
    let clone = [...newQuestions]

    clone[i].question = newTextArea
    clone[i].answer_type = newType

    clone = clone.map(question => ({
      ...question,
      edit_active: false
    }))

    setNewQuestions(clone)
  }

  const handleCancelAddQuestion = () => {
    setAddTextArea('')
    setAddType('text')
    setAddActive(false)
  }

  const handleCancelEditNewQuestion = i => {
    let clone = [...newQuestions]
    clone[i].edit_active = !clone[i].edit_active
    setNewQuestions(clone)
  }

  const handleDiscard = async () => {
    if (await AlertService.confirm("", 'Are you sure you want to discard all changes?')) {
      setOldQuestions(
        questions.map(question => ({ ...question, edit_active: false }))
      )
      setNewQuestions([])
    }
  }

  const handleAddNewQuestion = () => {
    let cloneOld = [...oldQuestions]
    let cloneNew = [...newQuestions]

    cloneOld = cloneOld.map(question => ({
      ...question,
      edit_active: false
    }))

    cloneNew = cloneNew.map(question => ({
      ...question,
      edit_active: false
    }))

    setOldQuestions(cloneOld)
    setNewQuestions(cloneNew)
    setAddActive(true)
  }

  const handleInsertNewQuestion = async () => {
    if (!addTextArea) {
      ToastUtil.error('Question cannot be empty.')
      return false
    }

    if (await AlertService.confirm("", 'Are you sure you want to add this question?')) {
      let api_path = `/client/${client_id}/survey`
      let response = await newFetch(POST, api_path, {
        questions: [
          {
            question: addTextArea,
            answer_type: addType
          }
        ]
      })

      ToastUtil.success(response.message)
      
      if (response.success) {
        fetchClientSurveys()
      }
      // let clone = [...newQuestions]
      // clone.push({
      //   question: addTextArea,
      //   answer_type: addType,
      //   edit_active: false
      // })

      // setNewQuestions(clone)

      // setAddActive(false)
      // setAddTextArea('')
      // setAddType('text')
    }
  }

  const handleToggleOldQuestionActive = async (status, index) => {
    if (
      await AlertService.confirm("", `Are you sure you want to set this question as ${
          status ? 'active' : 'inactive'
        }?`)
    ) {
      let clone = [...oldQuestions]
      let api_path = `/survey/${clone[index].id}/${
        status ? 'activate' : 'deactivate'
      }`
      let response = await newFetch(PUT, api_path)

      if (response.success) {
        clone[index].active = status
        setOldQuestions(clone)
      }
    }
  }

  const deleteQuestion = async survey_id => {
    if (await AlertService.confirm("", 'Are you sure you want to delete this question?')) {
      let api_path = `/survey/${survey_id}`
      let response = await newFetch(DELETE, api_path)

      ToastUtil.success(response.message)

      if (response.success) {
        fetchClientSurveys()
      }
    }
  }

  // const removeOldQuestion = index =>
  //   setOldQuestions([...oldQuestions].filter((question, i) => i !== index))

  const removeNewQuestion = async (index) => {
    if (
      await AlertService.confirm("", 'Are you sure you want to remove this newly added question?')
    ) {
      setNewQuestions([...newQuestions].filter((question, i) => i !== index))
    }
  }

  useEffect(() => {
    fetchClient()
  }, [])

  useEffect(() => {
    if (client) {
      fetchClientSurveys()
    }
  }, [client])

  // useEffect(() => {
  //   if (oldQuestions.length > 0) {
  //     let active = oldQuestions.find(question => question.active)

  //     if (active) {
  //       setOldTextArea(active.question)
  //       setOldType(active.answer_type)
  //     }
  //   }
  // }, [oldQuestions])

  useEffect(() => {
    if (newQuestions.length > 0) {
      let active = newQuestions.find(question => question.edit_active)

      if (active) {
        setNewTextArea(active.question)
        setNewType(active.answer_type)
      }
    }
  }, [newQuestions])

  const submitHandler = async e => {
    e.preventDefault()

    if (
      await AlertService.confirm("", 'Are you sure you want to update this client details?')
    ) {
      if (newQuestions.length > 0) {
        let create_api_path = `/client/${client_id}/survey`
        let create_response = await newFetch(POST, create_api_path)

        ToastUtil.success(create_response.message)
        if (create_response.success) {
          history.goBack()
        }
      }
    }
  }

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to={`/clients/client/${client_id}`}
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div>
                <i className="fas fa-chevron-left pe-2"></i>{' '}
                {client ? client.name : ''}
              </div>
            </NavLink>
            <div className="pt-4">
              <h3>Edit Pulse</h3>
            </div>
          </div>
          <form onSubmit={submitHandler}>
            {/* <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem'
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem'
                }}
                className="border-right"
              >
                <strong>Pulse</strong>
                <p className="pt-2">Manage client's pulse notification</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-top justify-content-between">
                    <div className="d-flex flex-column flex-grow-1">
                      <strong>
                        Enable auto-sending pulse after every shift
                      </strong>
                      <p className="pt-2 text-muted">
                        Manual triggering of pulse notification is required on
                        Smart Scheduler if this feature is disabled.
                      </p>
                    </div>
                    <div
                      className="text-center justify-content-center"
                      style={{ width: '100px' }}
                    >
                      <Switch
                        checked={autoPulse}
                        onChange={({ target: { checked } }) =>
                          setAutoPulse(checked)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
                marginBottom: '3rem'
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem'
                }}
                className="border-right"
              >
                <strong>Pulse Survey</strong>
                <p className="pt-2">Manage pulse survey questions</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                {oldQuestions.length > 0 &&
                  oldQuestions.map((question, index) =>
                    !question.edit_active ? (
                      <div
                        key={`oldQuestion-${index}`}
                        className="rounded mb-3 p-4"
                        style={{
                          backgroundColor: '#fafafa',
                          cursor: 'pointer'
                        }}
                        onClick={() => handleEditView('old', index)}
                      >
                        <div className="d-flex">
                          <div
                            style={{ minWidth: '20px' }}
                            className={`me-3 ${
                              question.active ? 'text-success' : 'text-danger'
                            }`}
                          >
                            {`Q${index + 1}`}
                          </div>
                          <div className="d-flex-flex-column flex-grow-1">
                            <div>{question.question}</div>
                            <div className="d-flex flex-row align-items-center mt-1">
                              <legend
                                className="col-form-label text-muted"
                                style={{ width: '120px' }}
                              >
                                Response type:{' '}
                              </legend>
                              <div>{capitalize(question.answer_type)}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        key={`oldQuestion-${index}`}
                        className="border rounded mb-3 p-4"
                        style={{ backgroundColor: '#fafafa' }}
                      >
                        <div className="d-flex">
                          <div
                            style={{ minWidth: '20px' }}
                            className={`me-3 ${
                              question.active ? 'text-success' : 'text-danger'
                            }`}
                          >
                            {`Q${index + 1}`}
                          </div>
                          <div className="d-flex-flex-column flex-grow-1">
                            <div className="pb-2 border-bottom">
                              <div>{question.question}</div>
                              <div className="d-flex flex-row align-items-center mt-1">
                                <legend
                                  className="col-form-label text-muted"
                                  style={{ width: '120px' }}
                                >
                                  Response type:{' '}
                                </legend>
                                <div>{capitalize(question.answer_type)}</div>
                              </div>
                            </div>

                            {/* <textarea
                              name={`oldQuestion-${index}`}
                              id={`oldQuestion-${index}`}
                              rows="5"
                              className="form-control"
                              style={{ resize: 'none' }}
                              value={oldTextArea}
                              onChange={e => setOldTextArea(e.target.value)}
                            />
                            <div className="py-2 border-bottom">
                              <div className="d-flex flex-row align-items-center">
                                <legend
                                  className="col-form-label text-muted"
                                  style={{ width: '120px' }}
                                >
                                  Response type:{' '}
                                </legend>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`oldTypeOptions-${index}`}
                                    id={`oldOptionText-${index}`}
                                    value="text"
                                    checked={oldType === 'text'}
                                    onChange={e => setOldType(e.target.value)}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`oldOptionText-${index}`}
                                  >
                                    Text
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`oldTypeOptions-${index}`}
                                    id={`oldOptionRating-${index}`}
                                    value="rating"
                                    checked={oldType === 'rating'}
                                    onChange={e => setOldType(e.target.value)}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`oldOptionRating-${index}`}
                                  >
                                    Rating
                                  </label>
                                </div>
                              </div>
                            </div> */}
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div
                                className="text-danger"
                                style={{ cursor: 'pointer' }}
                                onClick={() => deleteQuestion(question.id)}
                              >
                                Delete
                              </div>
                              <div className="d-flex">
                                <button
                                  type="button"
                                  className="btn btn-outline-brand me-2"
                                  style={{ width: '200px' }}
                                  onClick={() =>
                                    handleCancelEditOldQuestion(index)
                                  }
                                >
                                  Cancel
                                </button>
                                {question.active ? (
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    style={{ width: '200px' }}
                                    onClick={() =>
                                      handleToggleOldQuestionActive(
                                        false,
                                        index
                                      )
                                    }
                                  >
                                    Deactivate
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-success"
                                    style={{ width: '200px' }}
                                    onClick={() =>
                                      handleToggleOldQuestionActive(true, index)
                                    }
                                  >
                                    Activate
                                  </button>
                                )}
                                {/* <button
                                  type="button"
                                  className="btn btn-brand"
                                  style={{ width: '200px' }}
                                  onClick={() => handleSaveOldQuestion(index)}
                                >
                                  Save
                                </button> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                {newQuestions.map((question, index) =>
                  !question.edit_active ? (
                    <div
                      key={`newQuestion-${index}`}
                      className="rounded mb-3 p-4"
                      style={{
                        backgroundColor: '#fafafa',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleEditView('new', index)}
                    >
                      <div className="d-flex">
                        <div style={{ minWidth: '20px' }} className="me-3">
                          {`Q${oldQuestions.length + index + 1}`}
                        </div>
                        <div className="d-flex-flex-column flex-grow-1">
                          <div>{question.question}</div>
                          <div className="d-flex flex-row align-items-center mt-1">
                            <legend
                              className="col-form-label text-muted"
                              style={{ width: '120px' }}
                            >
                              Response type:{' '}
                            </legend>
                            <div>{capitalize(question.answer_type)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      key={`newQuestion-${index}`}
                      className="border rounded mb-3 p-4"
                      style={{ backgroundColor: '#fafafa' }}
                    >
                      <div className="d-flex">
                        <div style={{ minWidth: '20px' }} className="me-3">
                          {`Q${oldQuestions.length + index + 1}`}
                        </div>
                        <div className="d-flex-flex-column flex-grow-1">
                          <textarea
                            name={`newQuestion-${index}`}
                            id={`newQuestion-${index}`}
                            rows="5"
                            className="form-control"
                            style={{ resize: 'none' }}
                            value={newTextArea}
                            onChange={e => setNewTextArea(e.target.value)}
                          />
                          <div className="py-2 border-bottom">
                            <div className="d-flex flex-row align-items-center">
                              <legend
                                className="col-form-label text-muted"
                                style={{ width: '120px' }}
                              >
                                Response type:{' '}
                              </legend>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name={`newTypeOptions-${index}`}
                                  id={`newOptionText-${index}`}
                                  value="text"
                                  checked={newType === 'text'}
                                  onChange={e => setNewType(e.target.value)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`newOptionText-${index}`}
                                >
                                  Text
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name={`newTypeOptions-${index}`}
                                  id={`newOptionRating-${index}`}
                                  value="rating"
                                  checked={newType === 'rating'}
                                  onChange={e => setNewType(e.target.value)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`newOptionRating-${index}`}
                                >
                                  Rating
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div
                              className="text-danger"
                              style={{ cursor: 'pointer' }}
                              onClick={() => removeNewQuestion(index)}
                            >
                              Remove
                            </div>
                            <div className="d-flex">
                              <button
                                type="button"
                                className="btn btn-outline-brand me-2"
                                style={{ width: '200px' }}
                                onClick={() =>
                                  handleCancelEditNewQuestion(index)
                                }
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="btn btn-brand"
                                style={{ width: '200px' }}
                                onClick={() => handleSaveNewQuestion(index)}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
                {!addActive ? (
                  <div
                    onClick={handleAddNewQuestion}
                    className="border rounded mt-3"
                    style={{
                      paddingLeft: '2.25rem',
                      paddingRight: '2.25rem',
                      paddingTop: '1.5rem',
                      paddingBottom: '1.5rem',
                      cursor: 'pointer'
                    }}
                  >
                    <i className="fas fa-plus"></i>&nbsp;&nbsp;&nbsp;
                    <strong>Add Pulse Questions</strong>
                  </div>
                ) : (
                  <div
                    key={`newQuestion`}
                    className="border rounded p-4"
                    style={{ backgroundColor: '#fafafa' }}
                  >
                    <div className="d-flex">
                      <div style={{ minWidth: '20px' }} className="me-3">
                        {`Q${oldQuestions.length + newQuestions.length + 1}`}
                      </div>
                      <div className="d-flex-flex-column flex-grow-1">
                        <textarea
                          name={`newQuestion`}
                          id={`newQuestion`}
                          rows="5"
                          className="form-control"
                          style={{ resize: 'none' }}
                          value={addTextArea}
                          onChange={e => setAddTextArea(e.target.value)}
                        />
                        <div className="py-2 border-bottom">
                          <div className="d-flex flex-row align-items-center">
                            <legend
                              className="col-form-label text-muted"
                              style={{ width: '120px' }}
                            >
                              Response type:{' '}
                            </legend>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name={`newTypeOptions`}
                                id={`newOptionText`}
                                value="text"
                                checked={addType === 'text'}
                                onChange={e => setAddType(e.target.value)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`newOptionText`}
                              >
                                Text
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name={`newTypeOptions`}
                                id={`newOptionRating`}
                                value="rating"
                                checked={addType === 'rating'}
                                onChange={e => setAddType(e.target.value)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`newOptionRating`}
                              >
                                Rating
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end align-items-center mt-3">
                          <button
                            type="button"
                            className="btn btn-outline-brand me-2"
                            style={{ width: '200px' }}
                            onClick={handleCancelAddQuestion}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-brand"
                            style={{ width: '200px' }}
                            onClick={handleInsertNewQuestion}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* <div
              style={{
                position: 'fixed',
                bottom: 0,
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem'
              }}
              className="border-top bg-white d-flex align-items-center justify-content-end"
            >
              <button
                type="button"
                onClick={handleDiscard}
                className="btn btn-outline-brand"
                style={{ width: '12rem' }}
              >
                Discard
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3"
                style={{ width: '12rem' }}
              >
                Save changes
              </button>
            </div> */}
          </form>
        </div>
      )}
    </LayoutContext.Consumer>
  )
}

export default withRouter(EditPulse)
